// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

/**
 * Generates a unique file name by adding a version suffix if the file name already exists
 * @param fileName - The original file name
 * @param existingFileNames - Array of existing file names to check against
 * @returns A unique file name with version suffix if needed
 */
const generateUniqueFileName = (fileName: string, existingFileNames: string[]): string => {
  // If no existing files with the same name, return the original name
  if (!existingFileNames.includes(fileName)) {
    return fileName;
  }

  // Split the file name and extension
  const lastDotIndex = fileName.lastIndexOf('.');
  if (lastDotIndex === -1) {
    // No extension, just add version suffix
    let version = 1;
    let newFileName = `${fileName}_${version}`;
    while (existingFileNames.includes(newFileName)) {
      version += 1;
      newFileName = `${fileName}_${version}`;
    }
    return newFileName;
  }

  const nameWithoutExtension = fileName.substring(0, lastDotIndex);
  const extension = fileName.substring(lastDotIndex);

  let version = 1;
  let newFileName = `${nameWithoutExtension}_${version}${extension}`;

  while (existingFileNames.includes(newFileName)) {
    version += 1;
    newFileName = `${nameWithoutExtension}_${version}${extension}`;
  }

  return newFileName;
};

export default generateUniqueFileName;
